import React from "react";
import "./AnalyticSecure.css";

export default function AnalyticSecure() {
  return (
    <div id="analytics-secure" className="outsourcemainclass">
        <div className="overlay"></div>
      <div className="left">
        <h2 className="heading">
          Powering Faster Delivery with DevOps Automation
        </h2>
        <p className="subheading">
          At BastionEx, we deliver intelligent DevOps automation services that
          accelerate deployments, streamline workflows, and improve software
          reliability. Our solutions reduce manual effort, enhance
          collaboration, and enable continuous delivery for scalable,
          high-performance operations.
        </p>
        <button>Book your free consultation</button>
      </div>
      {/* <div className="right">
            <img src={img} alt="error" />
        </div> */}
    </div>
  );
}
